import React from 'react'
import {useSelector} from 'react-redux'
import {selectViewOrder} from 'app/features/orders/redux/order/orderSlice'
import {useNavigate, useParams} from 'react-router-dom'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {RootState} from 'setup'
import {orderFulfillmentStatusTypes, typesPayment} from 'app/features/orders/models'
import {Button} from '_core'

interface Props {
  fulfillmentId: string
}

export const CreateRefund: React.FC<Props> = ({fulfillmentId}) => {
  const {orderId} = useParams<any>()
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)

  const history = useNavigate()

  const handleRefund = async () => {
    history(`/orders/${orderId}/refund/${fulfillmentId}`)
  }

  if (
    (order.fulfillmentStatus === orderFulfillmentStatusTypes.fulfilled ||
      order.fulfillmentStatus === orderFulfillmentStatusTypes.partial) &&
    !order.isPaidByGiftCard
  ) {
    return (
      <Button
        id='btnSave'
        type='button'
        title='Refund'
        className='btn-primary w-100'
        isSubmitting={false}
        onClick={handleRefund}
      />
    )
  }
  return null
}

export default CreateRefund
